module.exports = __webpack_public_path__ + "static/win-do-not-run-annotated-516907095e1962df98473667507a8966.png";